var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 2.66699C13.8864 2.66699 14.6865 3.29145 14.9092 4.18164L15.4473 6.33301H17.5V6.41699H17.833C18.1091 6.41699 18.333 6.64085 18.333 6.91699V7.75C18.333 8.02614 18.1091 8.25 17.833 8.25H17.5V17.333C17.5 18.4376 16.6046 19.333 15.5 19.333H6.5C5.39543 19.333 4.5 18.4376 4.5 17.333V8.25H4.16699C3.89085 8.25 3.66699 8.02614 3.66699 7.75V6.91699C3.66699 6.64085 3.89085 6.41699 4.16699 6.41699H4.5V6.33301H6.55273L7.08984 4.18164C7.31245 3.29157 8.11281 2.66722 9.03027 2.66699H12.9688ZM6.5 17.333H15.5V8.33301H6.5V17.333ZM9.58301 10.083C9.85904 10.083 10.0828 10.307 10.083 10.583V15.083C10.083 15.3591 9.85915 15.583 9.58301 15.583H8.75C8.47386 15.583 8.25 15.3591 8.25 15.083V10.583C8.25018 10.307 8.47397 10.083 8.75 10.083H9.58301ZM13.25 10.083C13.526 10.083 13.7498 10.307 13.75 10.583V15.083C13.75 15.3591 13.5261 15.583 13.25 15.583H12.417C12.1409 15.583 11.917 15.3591 11.917 15.083V10.583C11.9172 10.307 12.141 10.083 12.417 10.083H13.25ZM8.61328 6.33301H13.3857L12.9688 4.66699H9.03027L8.61328 6.33301Z",
    fill: "#5C5C5C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1a2a5f181ee1c68e4e0f4b05df05e43c.svg";
export { ForwardRef as ReactComponent };